export function counterpartyIconResolver(cpiD: number | undefined) {
  if (!cpiD) {
    return 'assets/images/counterparties/undefined.webp';
  }

  const iconMap: Record<number, string> = {
    801: 'alfa',
    19: 'alfa',
    1023: 'gazprom',
    1036: 'gazprom',
    456: 'gazprom',
    1048: 'gazprom',
    888: 'psb',
    915: 'psb',
    1402: 'reso',
    1646: 'reso',
    811: 'rosagro',
    407: 'rosagro',
    488: 'rosbank',
    222: 'sber',
    1432: 'sber',
    921: 'sber',
    1127: 'vtb',
    1189: 'vtb',
    1330: 'vtb',
    68: 'vtb',
    1022: 'xkeeper',
    1: 'xkeeper',
    1025: 'xkeeper',
  };

  return `assets/images/counterparties/${iconMap[cpiD] || 'undefined'}.webp`;
}
